import React from 'react';
import {Box} from '@mui/material';
import {Link} from 'react-router-dom';
import {NAVY, TEXTE_SECONDAIRE} from '../../tokens.js';
import {formatNombre} from './dashboard.selectors.js';
import {carteSx, libelleCarteSx, lienCarteSx} from './dashStyles.js';

// R3 : alertes (4 au lot 5, réparties par bandeau au lot 9 ; `colonnes` = largeur de la grille) à date (indépendantes de la période), chacune lien vers la carte filtrée.
// Rayon 16 (handoff §1 et guide UI) : Dashboard.dc.html dessine 4 px sur ces tuiles, écart signalé au lead.

const SVG = {width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2.2, strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true};

const ICONES = {
    impossiblesConsecutifs: <svg {...SVG}><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>,
    enDefaut: <svg {...SVG}><path d="M12 3 2.5 20h19L12 3z"/><path d="M12 10v4"/><path d="M12 17h.01"/></svg>,
    signalements: <svg {...SVG}><path d="M4 4h16v11H8l-4 4z"/></svg>,
    plein: <svg {...SVG}><path d="M5 8h14l-1.5 12h-11z"/><path d="M4 5h16"/><path d="M9 5V3h6v2"/></svg>,
    sousUtilisees: <svg {...SVG}><path d="M5 8h14l-1.5 12h-11z"/><path d="M4 5h16"/><path d="M8 16h8"/></svg>,
    declassesRecurrents: <svg {...SVG}><path d="M12 3 2.5 20h19L12 3z"/><path d="M12 10v4"/><path d="M12 17h.01"/></svg>,
    condamnees: <svg {...SVG}><path d="M7.9 2.5h8.2l5.4 5.4v8.2l-5.4 5.4H7.9l-5.4-5.4V7.9z"/><path d="m9 9 6 6M15 9l-6 6"/></svg>,
};

function Contenu({tuile, cliquable}) {
    return (
        <>
            <Box component="span" sx={libelleCarteSx}>{ICONES[tuile.id]}{tuile.titre}</Box>
            <Box component="span" sx={{fontSize: 36, fontWeight: 800, lineHeight: 1.1, color: NAVY}}>{formatNombre(tuile.nb)}</Box>
            <Box component="span" sx={{fontSize: 12, color: TEXTE_SECONDAIRE}}>{tuile.sousLigne}</Box>
            {cliquable && <Box component="span" sx={{mt: '6px', fontSize: 12, fontWeight: 600}}>Voir sur la carte →</Box>}
        </>
    );
}

export default function DashAlertes({tuiles, liens, colonnes = 4, label = 'Alertes sur le patrimoine'}) {
    return (
        <Box component="section" aria-label={label} sx={{display: 'grid', gridTemplateColumns: `repeat(${colonnes}, minmax(0, 1fr))`, gap: '16px'}}>
            {tuiles.map((t) => (t.filtre ? (
                <Box key={t.id} component={Link} to={liens[t.id]} sx={{...lienCarteSx, gap: '6px', p: '18px 20px'}}>
                    <Contenu tuile={t} cliquable/>
                </Box>
            ) : (
                // Valeur non raccordée : tuile grisée, non cliquable.
                <Box key={t.id} aria-disabled="true" sx={{...carteSx, display: 'flex', flexDirection: 'column', gap: '6px', p: '18px 20px', opacity: 0.6, backgroundColor: '#F6F8F4'}}>
                    <Contenu tuile={t} cliquable={false}/>
                </Box>
            )))}
        </Box>
    );
}
